import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTable } from 'react-table';
import StatusTextIcon from "../../../../components/CoreComponents/StatusTextIcons";
import { RootState } from "../../../../store/store";
import { getDetilsFieldsArray } from "./useChecklistItemData";
import TrainingLinks from "../../../../components/CoreComponents/TrainingLinks";

export default function useCheckItemDetails({ item }) {
    const { DrilldownMappingsAPIResponse } = useSelector((state: RootState) => state.SequenceObject);

    // Use the item's drilldownTypeId to find the correct mapping
    const DrilldownMappingObject = DrilldownMappingsAPIResponse.find(d => d.drilldownTypeId === item?.drilldownTypeId)

    const data = useMemo(() => getDetilsFieldsArray(item, DrilldownMappingObject).map(r => {
        if (r.link) {
            r.value = <div className="flex flex-col gap-2">
                <TrainingLinks links={r.value} />
            </div>
        }
        if (r.name === 'Status') {
            r.value = <StatusTextIcon statusId={r.value} />;
        }
        return r;
    }), [item]);

    const columns = useMemo(() => [
        {
            accessor: 'name',
        },
        {
            accessor: 'value',
            Cell: ({ value }) => {
                return typeof value === 'object' ? value : <div>{value}</div>;
            }
        },
    ], []);

    return { ...useTable({ columns, data }) };
}
